import { create } from 'zustand';

/**
 * Session record of entries cashed out in place, so the open card keeps its confirmed layout while the open
 * list is left un-invalidated. Pins are never evicted; the adapter gates them on the entry still being open.
 * Backend-agnostic: one store per product (`<TEntry>`) so id spaces never collide.
 */
export type CashedOutEntriesStore<TEntry> = {
    entries: Map<string, TEntry>;
    markCashedOut: (entryId: string, entry: TEntry) => void;
};

export const createCashedOutEntriesStore = <TEntry>() =>
    create<CashedOutEntriesStore<TEntry>>(set => ({
        entries: new Map<string, TEntry>(),
        markCashedOut: (entryId, entry) =>
            set(state => {
                const entries = new Map(state.entries);
                entries.set(entryId, entry);
                return { entries };
            }),
    }));
